import appConfig from '@/config/appConfig.typed';
import type {SsoLinkEntry} from '@/state/slices/mediaSlice';

import {shouldRequestIccLoginTokenListSessionInfo} from './ssoIccSessionInfoPolicy';

export type ResolveSsoLinkUrlForOpenInput = {
    entry: Pick<SsoLinkEntry, 'url' | 'directUrl'>;
    openInBluefy: boolean;
    isDcxMarket: boolean;
    lastSsoSessionApplyAt: number | null;
};

/**
 * Picks the URL to open from cached ICC data. Batch responses always carry `url` (ICC Url);
 * `directUrl` is used for DCX cookie flow only when cookies are already established.
 */
export const resolveSsoLinkUrlForOpen = ({
    entry,
    openInBluefy,
    isDcxMarket,
    lastSsoSessionApplyAt,
}: ResolveSsoLinkUrlForOpenInput): string | undefined => {
    const {url, directUrl} = entry;

    if (!url) return undefined;

    if (openInBluefy) return url;

    if (!appConfig.getIsSsoCookiesEnabled() || !isDcxMarket) return url;

    const needSessionInfo = shouldRequestIccLoginTokenListSessionInfo({
        isDcxMarket: true,
        allowSessionInfo: true,
        lastSsoSessionApplyAt,
    });

    if (needSessionInfo) return url;

    return directUrl ?? url;
};
